module.exports = __webpack_public_path__ + "static/media/icon-financeiro.7d914102.svg";